import { createPublicClient, http } from "viem"

import { chainToWagmiChain } from "@/web3/constants/rpc"
import { getChainByChainId } from "@/web3/helpers/findChain"

/**
 * Creates a Viem public client for interacting with a specific blockchain network.
 *
 * @param {string} chainId - The chain ID of the blockchain network to connect to.
 *                           This should be a valid chain ID string that exists in the system.
 *
 * @returns {import('viem').PublicClient | null} Returns a configured Viem public client instance
 *                                              if the chain is found and RPC URL is available,
 *                                              otherwise uses default viem http rpc url.
 *
 * @example
 * const provider = createViemPublicProvider("eip155:1") // For Ethereum Mainnet
 * const provider = createViemPublicProvider(ChainId.EthereumMainnet) // For Ethereum Mainnet
 */
const createViemPublicProvider = (chainId: string) => {
  const chain = getChainByChainId(chainId)

  if (!chain) {
    console.error("No chain found for chainId", chainId)

    return null
  }

  const rpcUrlEnvVar = process.env[chain.envRPCArg ?? ""]

  return createPublicClient({
    chain: chainToWagmiChain(chain),
    transport: http(rpcUrlEnvVar),
  })
}

export default createViemPublicProvider
